import {
  collection,
  doc,
  query,
  orderBy,
  serverTimestamp,
  setDoc,
  deleteDoc,
  type DocumentData,
  type FirestoreDataConverter,
  type Query,
  type WithFieldValue,
} from 'firebase/firestore';

import { firestore } from './config';
import { USE_API, api, apiQuery } from '@/services/api/client';
import type { Proveedor } from '@/types/domain';

const proveedorConverter: FirestoreDataConverter<Proveedor> = {
  toFirestore(data: WithFieldValue<Proveedor>): DocumentData {
    return data as DocumentData;
  },
  fromFirestore(snap, options) {
    const data = snap.data(options) as Omit<Proveedor, 'id'>;
    return { id: snap.id, ...data };
  },
};

export const proveedoresCollection = collection(firestore, 'proveedores').withConverter(proveedorConverter);

export const proveedoresQuery: any = USE_API
  ? apiQuery('/proveedores', { _order: 'nombre' })
  : query(proveedoresCollection, orderBy('nombre'));

export interface UpsertProveedorInput {
  id?: string;
  nombre: string;
  whatsapp: string;
  telefono?: string;
  email?: string;
  notas?: string;
  horarios?: string;
  horaApertura?: string;
  horaCierre?: string;
  diasNoAtiende?: number[];
}

export async function upsertProveedor(input: UpsertProveedorInput) {
  if (USE_API) {
    if (input.id) return (await api.patch(`/proveedores/${input.id}`, input)).id;
    return (await api.post('/proveedores', input)).id;
  }
  const id = input.id ?? doc(proveedoresCollection).id;
  const ref = doc(proveedoresCollection, id);
  await setDoc(
    ref,
    {
      ...input,
      updatedAt: serverTimestamp(),
      ...(input.id ? {} : { createdAt: serverTimestamp() }),
    } as any,
    { merge: true },
  );
  return id;
}

export async function eliminarProveedor(id: string) {
  if (USE_API) return void (await api.delete(`/proveedores/${id}`));
  await deleteDoc(doc(proveedoresCollection, id));
}
